import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.672 1.668a.75.75 0 0 0-1.345 0L8.47 7.458a.25.25 0 0 1-.188.136l-6.39.934a.75.75 0 0 0-.415 1.28L6.1 14.31a.25.25 0 0 1 .072.222L5.08 20.893a.75.75 0 0 0 1.088.79l5.715-3.004a.25.25 0 0 1 .232 0l5.715 3.005a.75.75 0 0 0 1.088-.79l-1.091-6.362a.25.25 0 0 1 .072-.222l4.623-4.503a.75.75 0 0 0-.415-1.28l-6.39-.933a.25.25 0 0 1-.188-.137l-2.858-5.789Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }